export default __webpack_public_path__ + "static/media/ab-icon-active.285c52d8.svg";